
import {
    CONFIRMED_GET_IMPORTANT_QUESTIONS,
  } from "../actions/ImportantQuestionType"; 
  
  const initialState = {
    importantQuestions: [],
  };
  
  export default function ImportantQuestionsReducer(state = initialState, action) {
    if (action.type === CONFIRMED_GET_IMPORTANT_QUESTIONS) {
      return {
        ...state,
        importantQuestions: action.payload
      };
    }
    return state;
  }
  